export default __webpack_public_path__ + "static/media/glrc-course.plant-based-plate.7459d54b.png";